export default function IconUser() {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.99999 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 7.99999 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 7.99999 8Z" fill="currentColor" />
      <path d="M8 10C10.1217 10 12.1566 10.8429 13.6569 12.3431C14.9201 13.6064 15.7172 15.2486 15.9376 17.0026C16.0065 17.5505 15.5523 18 15 18H1C0.447715 18 -0.00645391 17.5505 0.0623925 17.0026C0.282756 15.2486 1.0799 13.6064 2.34315 12.3431C3.84344 10.8429 5.87827 10 8 10Z" fill="currentColor" />
    </svg>
  );
}
